import { useState, useEffect, useCallback } from 'react';

const API_BASE = 'https://api.ruqqiasultanaclinic.com/api';
const API_TOKEN = 'A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2';

const useApiAdmittedPatients = () => {
  const [admittedPatients, setAdmittedPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdmitted = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/Patient/admittedpatientdetails/get`, {
        headers: {
          'accept': '*/*',
          'X-API-TOKEN': API_TOKEN,
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setAdmittedPatients(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
      setAdmittedPatients([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAdmitted();
  }, [fetchAdmitted]);

  return { admittedPatients, loading, error, refetch: fetchAdmitted };
};

export default useApiAdmittedPatients;